module.exports = __webpack_public_path__ + "img/trusted-company-1.1eb70681.png";